import { render, staticRenderFns } from "./download-file.vue?vue&type=template&id=66f82c01&"
import script from "./download-file.vue?vue&type=script&lang=js&"
export * from "./download-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports